import { IAccredation } from '@/interfaces/IAssessmentData';
import styles from './AssessmentReport.module.css';
import Image from 'next/image';
type props = {
    data: IAccredation
}
export function AssessmentAccreditation({ data }: props) {
    return <section className={`${styles.Our_accreditation} pt40 pb40`}>
        <div className="container">
            <div className={`${styles.Details_accreditation} textcenter`}>
                <h2 className="sectionHeading">{data?.our_accreditation_heading || 'Our Accreditation'}</h2>
                <p className={`${styles.max_para} font16 textcenter text666 fontThin`}>{data?.our_accreditation_sub_heading || 'Our motto is to curate 100% authentic and research-backed formulations for our patients to make every treatment solution safe and uncompromised.'}</p>
                <ul>
                    {data && data.our_accreditation_images && data.our_accreditation_images[0].map((f, idx) =>
                        <li key={idx}><Image src={f || "/assets/images/our-accreditation1.png"} alt="accreditation" className="imgResponsive" height={138} width={138} /></li>
                    )}
                </ul>
            </div>
        </div>
    </section>
}